// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"b3aa61cd","125":"2392710a","718":"587cf9d1"}[chunkId] + ".chunk.js";
};